import { StyledFamilyAndFriendsCardContainer, StyledUserName } from './styles'
import 'swiper/css'
import { Relationships } from 'store/api-slices/userSlice'
import FavoritePlayerImage from '../../../../../../shared/components/favorite-player-image/FavoritePlayerImage'
import { PersonalAreaSwiper } from '../../../personalAreaSwiper/PersonalAreaSwiper'

type FriendsFamilySwiperProps = {
  familyAndFriendsData: Relationships[]
}

export const FriendsFamilySwiper = ({
  familyAndFriendsData,
}: FriendsFamilySwiperProps) => {
  const friendsFamilySwiperSlides = familyAndFriendsData.map((user) => (
    <StyledFamilyAndFriendsCardContainer key={user.name}>
      <FavoritePlayerImage relationshipDetails={user} />
      <StyledUserName>{user.name}</StyledUserName>
    </StyledFamilyAndFriendsCardContainer>
  ))

  const slidesStyle = { maxWidth: 'min-content', height: 'auto' }

  return (
    <PersonalAreaSwiper
      slides={friendsFamilySwiperSlides}
      slidesKey="friendsAndFamily"
      slidesStyle={slidesStyle}
    />
  )
}
